<template>
	<div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-large-size-100 md-xlarge-size-60">
				<site-card
					title="Informations"
					icon="info">
					<template v-slot:header-actions>
						<div class="flex items-center space-x-3">
							<div>
								<md-button class="md-icon-button md-raised md-warning" :disabled="!site.id"
										   @mousedown="goToRoute($event, 'Site Informations Edit', { idSite: site.id })">
									<font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
								</md-button>
								<md-tooltip md-direction="top" style="min-width: max-content !important;">Modifier le site</md-tooltip>
							</div>
							<div>
								<md-button class="md-icon-button md-raised md-default m-0" :disabled="!site.id" @click="openDuplicateModal">
									<font-awesome-icon class="md-icon" :icon="['fa', duplicatePanel.loading ? 'sync-alt' : 'copy']" :class="{'animate-spin': duplicatePanel.loading}" />
								</md-button>
								<md-tooltip md-direction="top" style="min-width: max-content !important;">Dupliquer le site</md-tooltip>
							</div>
						</div>
						<div class="flex items-center space-x-3 pl-4">
							<div>
								<md-button class="md-icon-button md-raised md-info" :disabled="hasClientAreaAccount"
										   @click="createClientAreaAccount">
									<font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
								</md-button>
								<md-tooltip md-direction="top" style="min-width: max-content !important;">
									{{ hasClientAreaAccount ? 'Utilisateur déjà créé' : 'Ajouter un utilisateur Espace Client' }}
								</md-tooltip>
							</div>
							<div>
								<md-button class="md-icon-button md-raised md-info m-0" :disabled="!hasClientAreaAccount"
										   @click="loginToClientArea">
									<font-awesome-icon class="md-icon" :icon="['fa', 'external-link-alt']" />
								</md-button>
								<md-tooltip md-direction="top" style="min-width: max-content !important;">
									{{ hasClientAreaAccount ? 'Se connecter à l\'espace client' : 'Compte espace client inexistant'}}
								</md-tooltip>
							</div>
						</div>
					</template>
					<template v-slot:content>
						<site-informations :site="site"></site-informations>
					</template>
				</site-card>
                <site-card style="margin-top: 60px;"
                    title="Contrats"
                    icon="file-contract">
                    <template v-slot:content>
                        <site-contracts :site="site"></site-contracts>
                    </template>
                </site-card>
			</div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-40">
                <site-card
                    title="Contacts"
                    icon="address-book">
                    <template v-slot:content>
                        <site-contacts :site="site"></site-contacts>
                    </template>
                </site-card>
                <site-card style="margin-top: 60px;"
                    title="Notes"
                    icon="sticky-note">
                    <template v-slot:content>
                        <site-notes :site="site"></site-notes>
                    </template>
                </site-card>
            </div>
		</div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-large-size-100 md-xlarge-size-40">
				<site-card
					title="Documents"
					icon="folder-open">
					<template v-slot:content>
						<site-documents :site="site"
							@deleted="getSiteDetails"></site-documents>
					</template>
				</site-card>
			</div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-60">
                <site-card
                    title="Demandes"
                    icon="phone">
                    <template v-slot:header-actions>
                        <div>
                            <md-button class="md-icon-button md-raised md-info" :disabled="!site.id"
                                       @mousedown="goToRoute($event, 'Demand Add', {}, { clientId: $route.params.id, siteId: site.id })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                                <span class="leading-none ml-2 font-medium">Ajouter une demande</span>
                            </md-button>
                        </div>
                    </template>
                    <template v-slot:content>
                        <site-demands></site-demands>
                    </template>
                </site-card>
            </div>
		</div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-large-size-100 md-xlarge-size-60">
				<site-card
					title="Dispositifs en place"
					icon="cog">
					<template v-slot:content>
						<site-devices :idSite="site.id" :devices="site.devices" :plans="site.plans"
                            @deleted-plan="getSiteDetails"></site-devices>
					</template>
				</site-card>
			</div>
            <div class="md-layout-item md-large-size-100 md-xlarge-size-40">
                <site-card
                    title="Groupements"
                    icon="layer-group">
                    <template v-slot:content>
                        <site-device-groups :idSite="site.id" :isGroupActive="!!site.is_group_active"
                            :deviceGroups="site.device_groups"
                            @added="getSiteDetails" @deleted="getSiteDetails"></site-device-groups>
                    </template>
                </site-card>
            </div>
		</div>
        <div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<site-card
					title="Interventions"
					icon="list-alt">
                    <template v-slot:header-actions>
                        <div class="flex items-center space-x-3">
							<div>
								<md-button class="md-icon-button md-raised md-info" :disabled="!site.id"
										   @mousedown="goToRoute($event, 'Add Intervention', {}, { clientId: $route.params.id, siteId: site.id })">
									<font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
									<span class="leading-none font-medium ml-2">Ajouter une intervention ponctuelle</span>
								</md-button>
							</div>
							<div>
								<md-button class="md-icon-button md-raised md-info" :disabled="!site.id"
										   @mousedown="goToRoute($event, 'Demand Add', {}, { clientId: $route.params.id, siteId: site.id })">
									<font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
									<span class="leading-none ml-2 font-medium">Ajouter une demande</span>
								</md-button>
							</div>
							<div>
								<md-button class="md-icon-button md-raised md-info" :disabled="!site.id"
										   @mousedown="goToRoute($event, 'Planning Management', {}, {clientId: $route.params.id, siteId: site.id, year: $moment().format('YYYY'), type: 'contracts'})">
									<font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
									<span class="leading-none ml-2 font-medium">Voir les interventions à planifier</span>
								</md-button>
							</div>
						</div>
                    </template>
					<template v-slot:content>
                        <site-interventions type="site"></site-interventions>
					</template>
				</site-card>
			</div>
		</div>
		<md-drawer class="drawer-form" md-right md-fixed :md-active.sync="duplicatePanel.show" @md-closed="closePanel">
			<md-toolbar class="md-transparent py-0 px-3" md-elevation="0">
				<div class="md-layout md-gutter">
					<div class="md-layout-item">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'copy']" />
						</div>
						<h4 class="title">Duplication d'un site</h4>
					</div>
					<div class="md-layout-actions md-layout-item md-size-20 text-right align-center">
						<div class="flex items-center justify-end header-actions">
							<md-button class="md-icon-button md-raised md-warning" @click="closePanel">
								<font-awesome-icon class="md-icon" :icon="['fa', 'times']"></font-awesome-icon>
							</md-button>
						</div>
					</div>
				</div>
			</md-toolbar>
			<div class="px-3 mt-1 pb-3">
				<div class="drawer-content">
					<p class="text-sm"><span class="font-medium">Site source : </span> {{ site.name }}</p>
					<p class="text-sm"><span class="font-medium">Éléments transférés : </span></p>
					<div class="pl-4">
						<div class="flex items-center space-x-2">
							<font-awesome-icon class="md-icon w-auto mx-0" :icon="['fa', 'cog']" />
							<span class="text-sm">{{ site.devices.length }} dispositifs actifs</span>
						</div>
						<div class="flex items-center space-x-2">
							<font-awesome-icon class="md-icon w-auto mx-0" :icon="['fa', 'folder-open']" />
							<span class="text-sm">{{ site.documents.filter(document => { return document.type !== 2 }).length }} documents</span>
						</div>
						<div class="flex items-center space-x-2">
							<font-awesome-icon class="md-icon w-auto mx-0" :icon="['fa', 'layer-group']" />
							<span class="text-sm">{{ site.plans.length }} plans</span>
						</div>
					</div>
				</div>
				<md-divider class="my-3"></md-divider>
				<form @submit.prevent="duplicateSite">
					<p class="text-sm mb-2"><span class="font-medium">Veuillez choisir le site cible</span></p>
					<div class="md-layout md-gutter">
						<div class="md-layout-item">
							<div class="md-multiselect">
								<label>Site</label>
								<multiselect v-model="duplicatePanel.site"
											 :options="sites"
											 :show-labels="false"
								             :custom-label="formatSiteLabel"
											 track-by="id"
											 placeholder="Site">
									<template slot="option" slot-scope="props">
										<div class="option__desc">
											<div class="flex flex-col">
												<span class="option__title text-xs italic font-bold">{{ props.option.client.name }}</span>
												<span class="option__title">{{ props.option.name }}</span>
											</div>
										</div>
									</template>
									<template slot="noOptions">La liste est vide</template>
									<template slot="noResult">Aucun élement correspondant</template>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="panel-actions">
						<md-button class="md-icon-button md-raised md-success" type="submit" :disabled="duplicatePanel.waiting">
							<font-awesome-icon class="md-icon" :icon="['fa', duplicatePanel.waiting ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': duplicatePanel.waiting}"></font-awesome-icon>
							<span class="leading-none font-medium ml-2"> Valider</span>
						</md-button>
					</div>
				</form>
			</div>
		</md-drawer>
	</div>
</template>

<script>
// Components
import SiteCard from "@/pages/Sites/components/SiteCard";
import SiteInformations from "@/pages/Sites/Informations/Informations";
import SiteContacts from "@/pages/Sites/Contacts/Contacts";
import SiteNotes from "@/pages/Sites/Notes/Notes";
import SiteContracts from "@/pages/Sites/Contracts/Contracts";
import SiteDocuments from "@/pages/Sites/Documents/Documents";
import SiteDevices from "@/pages/Sites/Devices/Devices";
import SiteDeviceGroups from "@/pages/Sites/DeviceGroups/DeviceGroups";
import SiteDemands from "@/pages/Sites/Demandes/Demands";
import SiteInterventions from "@/components/Tables/DetailInterventionsTable";

// Mixins
import routerMixin from "@/mixins/router-mixin";

export default {
	name: "SiteDetails",
	components: {
		SiteCard, SiteInformations, SiteContacts, SiteContracts,
        SiteDocuments, SiteNotes, SiteDevices, SiteDeviceGroups, SiteDemands, SiteInterventions
	},
    mixins: [routerMixin],
	data() {
		return {
			site: {
				devices: [],
                device_groups: [],
                demands: [],
				documents: [],
                plans:[]
			},
			sites: [],
			duplicatePanel: {
				loading: false,
				waiting: false,
				show: false,
				site: null
			}
		}
	},
	computed: {
		hasClientAreaAccount() {
			return this.site.is_client_area_available && (this.site.username !== null && this.site.username !== '')
		}
	},
	methods: {
		async getSiteDetails() {
			const { data } = await this.$store.dispatch('sites/getSiteDetails', this.$route.params.idSite)
            let schedules = this.formatSchedules(data.schedules)
            this.site = {
                ...data,
                schedules: schedules,
                creation: this.$moment(data.created_at).format("DD MMMM yyyy"),
                modification: this.$moment(data.updated_at).format("DD MMMM yyyy")
            }
        },
        formatSchedules(data) {
            let schedules = []
            data.map(d => {
                let sameSchedule = schedules.filter(s => { return s.day_number === d.day_number })
                if(sameSchedule.length > 0) {
                    sameSchedule[0].schedules.push({
                        id: d.id,
                        start: d.start,
                        end: d.end
                    })
                } else {
                    let schedule = {
                        ...d,
                        schedules: [{
                            id: d.id,
                            start: d.start,
                            end: d.end
                        }]
                    }
                    schedules.push(schedule)
                }
            })
            return schedules
        },
		async createClientAreaAccount() {
			try {
				await this.$store.dispatch('sites/createClientAreaAccount', {
					site_id: this.site.id
				})
				await this.$store.dispatch('alerts/success', 'Compte espace client créé pour ce site')
				await this.getSiteDetails()
			} catch (e) {
				await this.$store.dispatch('alerts/error', e.response.data)
			}
		},
		async loginToClientArea() {
			const user = {
				data: {
					type: 'token',
					attributes: {
						username: this.site.username,
						password: this.site.password
					}
				}
			}

			const requestOptions = {
				headers: {
					Accept: "application/vnd.api+json",
					"Content-Type": "application/vnd.api+json",
				},
			}

			try {
				const { data } = await this.$store.dispatch('caLogin', { user, requestOptions })
				const clientArea = {
					accessToken: data.accessToken,
					userType: data.userType
				}
				localStorage.setItem("client-area", JSON.stringify(clientArea))
				let newRoute = this.$router.resolve({ name: 'caDashboard' })
				window.open(newRoute.href, '_blank')
			} catch (e) {}
		},
		async openDuplicateModal() {
			this.duplicatePanel.loading = true

			const { data } = await this.$store.dispatch('sites/fetchAllSitesForDuplication', {
				siteId: this.site.id
			})
			this.sites = data

			this.duplicatePanel.show = true
			this.duplicatePanel.loading = false
		},
		closePanel() {
			this.sites = []

			this.duplicatePanel.site = null
			this.duplicatePanel.show = false
		},
		async duplicateSite() {
			this.duplicatePanel.waiting = true

			try {
				const { data } = await this.$store.dispatch('sites/duplicateSite', {
					targetSiteId: this.site.id,
					site_id: this.duplicatePanel.site.id
				})
				await this.$store.dispatch('alerts/success', 'Duplication effectuée')
				await this.$router.push({ name: 'Site Details', params: { id: data.clientId, idSite: this.duplicatePanel.site.id } })
			} catch (e) {}

			this.duplicatePanel.waiting = false
		},
		formatSiteLabel(site) {
			return site.name + ' ' + site.client.name
		},
    },
    mounted() {
        this.getSiteDetails()
    },
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-layout.md-gutter {
        margin: 0;
        .md-layout-item {
            padding: 0 10px;

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                padding-right: 0;
            }
        }
    }
    .md-card.mt {
        margin-top: 40px !important;
    }

	.md-drawer {
		.drawer-content {
			.md-icon {
				margin: 0;
				max-width: 14px !important;
				min-width: 14px !important;
				font-size: 14px !important;

				color: $brand-primary;
			}
		}
	}
}
</style>
